import BaseEvent from "../BaseEvent";

export default class BeforeBasketFetchEvent extends BaseEvent {
    public requestParams: {
        name: string;
        value: string;
    }[] = [];

    constructor(initialRequestParams: { name: string; value: string }[] = []) {
        super();

        this.requestParams = initialRequestParams;
    }
}
